<template>
    <google-map ref="map" :center="center" :zoom="zoom" class="map" @click="expandMap" :options="{
        styles: mapStyles,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false
    }">
        <google-marker ref="myMarker" v-for="marker in mapMarkers" :key="marker.id" :title="marker.title"
            :position="marker.position" :icon="marker.icon" :label="marker.label" :visible="marker.visible"
            @click="onMapMarkerClick(marker.id)"></google-marker>
    </google-map>
</template>

<script>
import { mapActions } from "vuex";
import Vue from "vue";
import EventBus from "../functions/eventBus";
import * as VueGoogleMaps from "vue2-google-maps";
import { googleApi, defaultOpt, mapStyles } from "../../../config/map";

// Vue Google Maps Init
Vue.use(VueGoogleMaps, {
    load: {
        key: googleApi.mapKey,
        libraries: ["places"],
        v: "3.40"
    },
    installComponents: false
});

// Map Styles
const BRANCH_MARKER = "/Static/assets/images/branch.svg";
const ATM_MARKER = "/Static/assets/images/atm.svg";

export default {
    created() {
        EventBus.$on("mapBound", () => {
            this.newSearch = true;
        });
    },
    data() {
        return {
            center: defaultOpt.pos,
            zoom: defaultOpt.zoom,
            mapMarkers: null,
            mapMarkerIconSize: null,
            newSearch: false,
            showSearch: false,
            mapStyles: []
        }
    },
    mounted() {
        this.$refs.map.$mapPromise.then(() => {
            this.mapMarkerIconSize = new window.google.maps.Size(30, 30);
            this.mapMarkerSelectedSize = new window.google.maps.Size(50, 50);

            // if (this.isSpecificLocation) {
            //     setTimeout(()=> {  
            //         this.addMarkers([this.selectedLocation]);
            //     }, 500);
            // }
        });
    },
    components: {
        "google-map": VueGoogleMaps.Map,
        "google-marker": VueGoogleMaps.Marker
    },
    computed: {
        filteredLocations: {
            get() {
                return this.$store.getters.filteredLocations;
            }
        },
        isSpecificLocation: {
            get() {
                return this.$store.getters.isSpecificLocation;
            }
        },
        selectedLocation: {
            get() {
                return this.$store.getters.selectedLocation;
            },
            set(value) {
                this.updateSelectedLocation(value);
            }
        },
        userLocation: {
            get() {
                return this.$store.getters.userLocation;
            }
        },
        userSearch: {
            get() {
                return this.$store.getters.userSearch;
            }
        }
    },
    methods: {
        ...mapActions(["updateSelectedLocation", "updateLocations"]),

        addMarkers(locations) {
            let markers = {};
            for (let i = 0; i < locations.length; i++) {
                let location = locations[i];
                if (location === null) {
                    console.log('location was null');
                    continue;
                }

                const marker = {};
                marker.id = location.id;
                marker.index = i + 1;
                marker.title = location.name;
                marker.animation = 4;
                marker.visible = true;

                marker.position = {
                    lat: location.geocode.latitude,
                    lng: location.geocode.longitude
                };

                marker.icon = {
                    url: this.getMapIcon(location),
                    size: this.mapMarkerIconSize,
                    origin: new window.google.maps.Point(0, 0),
                    anchor: new window.google.maps.Point(0, 0),
                    labelOrigin: new window.google.maps.Point(55, 35),
                    //All of these settings were to try to fix a rendering issue with the custom icon. Ended up being fixed by adding an empty label (seen below)
                    scaledSize: this.mapMarkerIconSize,
                    optimized: false
                };

                marker.label = {
                    text: " ",
                    color: 'black',
                    fontWeight: 'bold',
                    fontSize: '12'
                };

                markers[location.id] = marker;
            }
            this.mapMarkers = markers;

            //Only bound map on new search location
            if (this.newSearch) {
                setTimeout(() => {
                    this.boundMarkers();
                }, 0);
            }
        },
        boundMarkers() {
            this.$gmapApiPromiseLazy().then(() => {
                const propOwn = Object.getOwnPropertyNames(this.mapMarkers);
                if (propOwn.length >= 2) {
                    const bounds = new window.google.maps.LatLngBounds();
                    for (var m in this.mapMarkers) {
                        if (this.mapMarkers.hasOwnProperty(m)) {
                            let lat = parseFloat(this.mapMarkers[m].position.lat);
                            let lng = parseFloat(this.mapMarkers[m].position.lng);
                            let myLatlng = new window.google.maps.LatLng(lat, lng);
                            bounds.extend(myLatlng);
                        }
                    }

                    // Don't zoom in too far on only one marker
                    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
                        var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.001, bounds.getNorthEast().lng() + 0.001);
                        var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.001, bounds.getNorthEast().lng() - 0.001);
                        bounds.extend(extendPoint1);
                        bounds.extend(extendPoint2);
                    }

                    this.$refs.map.fitBounds(bounds);
                    // Prevent bounding on filtering
                    this.newSearch = false;
                } else {
                    // No results no map bound, center on requested search
                    if (this.userSearch && this.userSearch.lat && this.userSearch.lng) {
                        this.panTo(this.userSearch);
                    } else if (this.userLocation && this.userLocation.lat && this.userLocation.lng) {
                        this.panTo(this.userLocation);
                    }
                }
            });
        },
        contractMap() {
            if (this.$mq !== 'desktop') {
                this.mobileExpandMap = false;
                EventBus.expandMap(false);
                setTimeout(() => {
                    EventBus.scrollToTopMobile();
                }, 600);
            }
        },
        expandMap() {
            if (this.selectedLocation) {
                EventBus.scrollToTopMobile(0);
            }
            this.mobileExpandMap = true;
            EventBus.expandMap(true);
            EventBus.scrollToTopMobile(0);
        },
        getMapIcon(location) {
            if (location.isAtm) {
                return ATM_MARKER;
            }
            return BRANCH_MARKER;
        },
        setMapMarkerVisibility(id, show = false) {
            for (let m in this.mapMarkers) {
                let marker = this.mapMarkers[m];

                if (marker.id != id) {
                    marker["visible"] = show;
                }
            }
        },
        panBack(location) {
            this.$refs.map.panTo(this.center);
        },
        panTo(latlng, zoom = defaultOpt.zoom) {
            if (latlng) {
                this.$refs.map.$mapPromise.then((map) => {
                    map.setZoom(zoom);
                    map.panTo({ lat: latlng.lat, lng: latlng.lng });
                });
            }
        },
        onMapMarkerClick(id) {
            if (!this.isSpecificLocation) {
                let selectedLoc = this.filteredLocations.find(item => item.id == id);
                window.location = selectedLoc.locationUrl;
            }
        },
        onMapMarkerHover(id, mouseOut) {
            if (!this.mapMarkers[id] || this.isSpecificLocation) return;

            const icon = {
                url: this.getMapIcon(this.mapMarkers[id]),
                scaledSize: mouseOut ? this.mapMarkerIconSize : this.mapMarkerSelectedSize
            };

            this.mapMarkers[id].icon = icon;
        },
        selectMapMarker(id, active) {
            if (this.mapMarkers && this.mapMarkers[id]) {
                if (!this.mapMarkers[id]) return;

                this.setMapMarkerVisibility(id);

                if (active) {
                    this.panTo(this.mapMarkers[id].position, 16);
                }
            }
        }
    },
    watch: {
        filteredLocations(newValue) {
            this.$refs.map.$mapPromise.then(() => {
                setTimeout(() => {
                    this.addMarkers(newValue);
                }, 500);
            });
        },

        mapMarkers(markers) {
            this.boundMarkers();
        },

        selectedLocation(newValue, oldValue) {
            if (newValue != null) {
                this.selectMapMarker(oldValue ? oldValue.id : null, false);
                this.selectMapMarker(newValue.id, true);

                if (this.isSpecificLocation) {
                    this.$refs.map.$mapPromise.then(() => {
                        setTimeout(() => {
                            this.addMarkers([newValue]);
                            this.setMapMarkerVisibility(null, true);
                            this.boundMarkers();
                        }, 500);
                    });
                }
            }

        },
        userSearch(newValue) {
            if (this.filteredLocations.length == 0) {
                if (newValue.lat && newValue.lng) {
                    this.center = newValue;
                }
            }
            // Flag for new search
            this.newSearch = true;
        }
    }
}
</script>
